import * as React from 'react';
import './style.css';
import { connect } from 'react-redux';
//import { Link } from 'react-router-dom';
import { getTranslation, SupportedLanguage } from 'Services/Geo';
import { RootState } from 'Redux/Store';

const headshot =  require("./christinawelsh.png")

const mapStateToProps = (state: RootState) => ({
  lang: state.status.lang,
  isPersist: state.status.isPersist
});

interface CaptionProps {
  lang: SupportedLanguage;
  isPersist: boolean;
}

class Caption extends React.Component<CaptionProps, {}> {
  render() {
    if (!this.props.isPersist) {
      return (null);
    }
    return (
      <div className="homeCaption">
        <div className="captionWrapper">
        <div className="headshot">
        <img src={headshot} alt="headshot"/>
        </div>
        <div className="homeCaption-info">
        <div className="homeTitle">{getTranslation(this.props.lang, 'Christina Welsh')}</div>
        <div className="homeSubtitle">
          {getTranslation(this.props.lang, 'Find your new home with me!')}
        </div>
        <div className="homeTitle">Full Site Coming Soon!</div>
        <div className="homeSubtitle">
        Phone: 773-600-6229
        </div>
        <div className="homeSubtitle">
Email: christina.l.welsh@gmail.com
</div>
<div className="homeSubtitle">
DRE #: 02145512
</div>
        </div>
        
      </div>
      </div>
      // this line below goes into the div above
      //<Link className="btn btn-black" to="/search">{getTranslation(this.props.lang, 'Learn More')}</Link>
    );
  }
}

export default connect(mapStateToProps)(Caption);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Scenes/HomePage/Components/Header/Components/Caption/index.tsx